@if (!user()) {
  <app-header [user]="user()" />
}

<section class="www-pro-edu-tra">
  @if (trainingDetails()) {
    <app-pro-edu-tra-top [trainingDetails]="trainingDetails()" />
    <app-pro-edu-tra-tic [trainingDetails]="trainingDetails()!" [markedEvent]="markedEvent()" />
  }

  @if (trainingDetails()) {
    <app-pro-edu-tra-info [trainingDetails]="trainingDetails()" />
  }

  <app-newsletter-section />
</section>
